import { useEffect } from "react";
import { Container } from "../Container/Container";
import { schoolArr } from "../Studies/ourSchoolObj";
import { routes } from "../../shared/routes/routes";
import {
  OurSchoolContainer,
  HeroBlock,
  Badge,
  Title,
  Accent,
  Subtitle,
  CardsGrid,
  Card,
  CardImageWrap,
  CardImage,
  CardOverlay,
  CardBody,
  CardTitle,
  CardSnippet,
  CardCTA,
} from "./styled";

export const OurSchool = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const items = Object.values(schoolArr);

  return (
    <Container>
      <OurSchoolContainer>
        <HeroBlock>
          <Badge>Наша школа</Badge>
          <Title>Образовательные ступени «Мечты»</Title>
          <Accent />
          <Subtitle>
            От подготовительных классов до выпуска — каждая ступень с собственной
            программой, опытными педагогами и проверенными методиками.
          </Subtitle>
        </HeroBlock>

        <CardsGrid>
          {items.map((item) => (
            <Card
              key={item.link}
              to={routes.ourSchoolSlug.replace(":slug", item.link)}
            >
              <CardImageWrap>
                <CardImage src={item.photo} alt={item.title} />
                <CardOverlay />
              </CardImageWrap>
              <CardBody>
                <CardTitle>{item.title}</CardTitle>
                <CardSnippet>{item.info[0]}</CardSnippet>
                <CardCTA>
                  Подробнее
                  <svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1 5H13M13 5L9 1M13 5L9 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                </CardCTA>
              </CardBody>
            </Card>
          ))}
        </CardsGrid>
      </OurSchoolContainer>
    </Container>
  );
};
